import * as React from 'react';
import YadoItemAsideView from './views/YadoItemAsideView';
import YadoItemRibon from './YadoItemRibon';
import { IYado, ICurrency } from '../types';
import YadoItemPrice from './YadoItemPrice';

interface IProps {
  yado: IYado,
  numberOfPeople: number,
  numberOfNights: number,
  currency: ICurrency,
}

const YadoItemAside: React.FC<IProps> = (props) => {
  const { yado } = props;

  function renderRating(id: string, rating: number|null) {
    if (rating == null || rating === 0) {
      return (
        <div className="rating__container" />
      );
    };
    const starCount = Math.round(rating / 2);
    const stars = [];
    for (let i = 0; i < starCount; i += 1) {
      stars.push(<i key={`${id}-star-${i}`} className="fas fa-star"></i>);
    }
    return (
      <div className="rating__container">
        <div className="rating__items">
          <div className="scoreRating">{rating}</div>
          <div className="starRating">
            {stars}
          </div>
        </div>
      </div>
    );
  }

  return (
    <YadoItemAsideView>
      {renderRating(yado.id, yado.rating)}
      <div>
        {yado.is_recommended && <YadoItemRibon type="wa"/>}
        <YadoItemRibon type="pickup"/>
        <YadoItemPrice {...props} />
      </div>
    </YadoItemAsideView>
  );
}

export default YadoItemAside;
